import { EyeOutlined } from '@ant-design/icons';
import { ButtonIcon } from '@framework/ui/components/button/ButtonIcon.tsx';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { getSubmissionPath } from '../../../submission/components/getSubmissionPath.ts';

export interface ISubmissionDetailButtonProps {
  submissionId?: string | null;
}

/**
 * Pulsante per visualizzare il dettaglio della richiesta dalla tabella notifiche.
 */
export function SubmissionDetailButton(props: ISubmissionDetailButtonProps) {
  const { submissionId } = props;

  const { t } = useTranslation();
  const theme = useTheme();

  if (!submissionId) return null;

  const label = t(
    'submission-list.visualizza-richiesta',
    'Visualizza richiesta',
  );

  return (
    <ButtonIcon
      aria-label={label}
      icon={<EyeOutlined aria-hidden="true" />}
      to={getSubmissionPath(theme.redirectToFirstModule, submissionId)}
      tooltip={label}
      tooltipProps={{ placement: 'bottomRight' }}
    />
  );
}
